import { DatePicker, Pagination } from 'antd';
import React, { useState } from 'react'
const { RangePicker } = DatePicker;
const tabs = [
  { id: 'all', name: '全部记录' },
]

export default function PointsDetail() {
  const [Loading, setLoading] = useState(false);
  const [pageWhere, setPageWhere] = useState({
    page: 1,
    pageSize: 5,
    total:0
  });

  function onPageChange(){}
  return (
    <div className="bg-white p-6">
      {/* 标题 */}
      <h2 className="text-xl font-bold mb-6">积分明细</h2>

      {/* 选项卡和搜索栏 */}
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-6">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`pb-2 ${
                tab.id === 'all' 
                  ? 'text-orange-500 border-b-2 border-orange-500' 
                  : 'text-gray-500'
              }`}
            >
              {tab.name}
            </button>
          ))}
        </div>

        {/* 日期筛选和搜索 */}
        <div className="flex items-center gap-4">
          <span>兑换日期 ：</span>
        <RangePicker
              className="custom-range-picker"
              renderExtraFooter={() => 'extra footer'}
              showTime
              separator="至"
              style={{ width: '300px' }} // 直接设置宽度
            />
          <button className="bg-orange-500 text-white px-4 py-1 rounded">搜索</button>
        </div>
      </div>

      {/* 表格 */}
      <table className="w-full">
        <thead className="bg-gray-50">
          <tr className="text-left">
            <th className="py-4 px-4">到账时间</th>
            <th className="py-4 px-4">说明</th>
            <th className="py-4 px-4">积分变化</th>
            <th className="py-4 px-4">积分余额</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {[...Array(9)].map((_, index) => (
            <tr key={index} className="hover:bg-gray-50">
              <td className="py-4 px-4 text-gray-600">2023-12-27 11:57:36</td>
              <td className="py-4 px-4">{index === 0 ? '兑换成功' : index === 1 ? '兑换成功' : '兑换成功'}</td>
              <td className="py-4 px-4 text-orange-500">
                {index === 0 ? '+10' : index === 1 ? '+90' : '+100'}
              </td>
              <td className="py-4 px-4">{9999}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* 分页 */}
      <Pagination
              defaultCurrent={pageWhere.page}
              total={pageWhere.total}
              defaultPageSize={pageWhere.pageSize}
              onChange={onPageChange}
              className="text-center"
            />
    </div>
  )
}